import { APP_TYPE } from '@intigral/constant/common';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { initializeDataDomain } from '../../DataDomain';
import { initializeConfigurationService } from '../../services/ConfigurationService';

export const useDataDomainContainer = (callback: () => void) => {
    const queryClient = useQueryClient();

    // Initialization registers DI services and axios interceptors, so it must run once per page
    // load; only an explicit invalidation (useRefreshConfiguration) may re-run it.
    return useQuery({
        queryKey: ['data-domain'],
        staleTime: Infinity,
        gcTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
        retry: false,
        queryFn: async () => {
            const result = await initializeDataDomain(APP_TYPE.WCP);

            // ✅ ARCHITECTURAL DECISION: useConfiguration is the SINGLE source of truth
            // Data Domain does NOT cache configuration to maintain clean separation
            // This enables future refactoring where methods receive config as parameters
            if (result && typeof result === 'object' && result.configuration) {
                // Initialize configuration service for library usage (backward compat)
                initializeConfigurationService(queryClient);
            }

            // Clear any existing configuration cache from localStorage
            if (typeof window !== 'undefined' && window.localStorage) {
                window.localStorage.removeItem('configuration.cache.object');
                window.localStorage.removeItem('baseConfiguration.cache.object');
            }

            callback();
            return result;
        },
    });
};
